module.exports = __webpack_public_path__ + "img/logo.989c64a1.png";